module.exports = __webpack_public_path__ + "static/media/992128.5fedc39e.png";